// "/gif <words>" (#632): in the message box it does not post. It opens the GIF picker with the words in its search box.
// One rule for every client; the cases are shared/cases/gif-command.json, which the Swift and Kotlin ports run too.
// "gif" is a reserved app slug (RESERVED_SLUGS in apps.ts), so the built-in command wins over any app.

/** What separates words here: a space, a tab, a line break or a no-break space (the same set on every client). */
const SPACE = /[ \t\n\r ]+/;

/** The command's name, without the slash. */
export const GIF_COMMAND = "gif";

/**
 * The picker's search words when the text is a "/gif" command, else null. "/gif foo bar" is "foo bar", "/gif" is "" (the
 * picker opens on its trending view), "/GIF cats" is "cats" and "/giffy" or "/gif/x" is null (not this command). Spaces
 * around the words go, and runs of spaces inside them become one.
 */
export function parseGifCommand(text: string): string | null {
  const words = text.split(SPACE).filter(Boolean);
  const head = words[0];
  if (head === undefined || head.toLowerCase() !== `/${GIF_COMMAND}`) return null;
  return words.slice(1).join(" ");
}

/**
 * Whether the "/" menu lists the built-in "Search GIFs" row for what follows the slash: always for a bare "/", for a
 * start of the name ("g", "GI", "gif") and for the command with words ("gif cats"); never for "giffy" or "gifs".
 */
export function gifMenuShows(query: string): boolean {
  const q = query.trimStart().toLowerCase();
  if (!q) return true;
  if (parseGifCommand(`/${q}`) !== null) return true;
  return !SPACE.test(q) && GIF_COMMAND.startsWith(q);
}
